import type { ReactNode } from "react";

// The platform console's nav glyphs. Same drawing contract as the product's
// (apps/web/src/app/navIcons.tsx): a 24x24 grid, `currentColor` stroke, no glyph setting its own
// fill/stroke — collapsed to the rail the icon is ALL there is of a row, and an icon that hard-codes a
// colour goes invisible on the active row, where the background is the accent.
//
// Its own set rather than a shared one, so each entry's vocabulary is exactly the rows it renders and
// each app's "no glyph the sidebar never renders" guardrail stays a simple statement about one file
// (nav-icons.test.mjs here and in apps/web).
export type NavIconName = "tenants" | "parameters";

const PATHS: Record<NavIconName, ReactNode> = {
  // Two buildings on a ground line — the tenants are the organisations on the
  // platform, so a building beats a person or a folder here.
  tenants: (
    <>
      <path d="M2.5 20.5h19" />
      <path d="M4.5 20.5V6a1 1 0 0 1 .7-1l6-1.9a1 1 0 0 1 1.3 1v16.4" />
      <path d="M12.5 11h6a1 1 0 0 1 1 1v8.5" />
      <path d="M7.5 8.5h1.5M7.5 12h1.5M7.5 15.5h1.5M15 14.5h1.5" />
    </>
  ),

  // Sliders — settings that are tuned, distinct at a glance from the buildings
  // directly above it in the same section (a cog and a building read alike in a
  // 20px rail once both are reduced to a round outline).
  parameters: (
    <>
      <path d="M4 7h8.5M17.5 7h2.5M4 12h2.5M11.5 12h8.5M4 17h8.5M17.5 17h2.5" />
      <circle cx="15" cy="7" r="2.2" />
      <circle cx="9" cy="12" r="2.2" />
      <circle cx="15" cy="17" r="2.2" />
    </>
  ),
};

export function NavIcon({ name }: { name: NavIconName }) {
  return (
    <svg
      className="app-nav__icon"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {PATHS[name]}
    </svg>
  );
}
